
import { useSelector } from 'react-redux';

import { FunctionalRootState } from '@share/utils';
import { ILoginState, IMenuState } from '@share/store/slices';
import { JotformEmbed, Loading } from '@share/components';

import './style.scss';

const MLM_CONTACT_US_FORM = 'https://form.jotform.com/250377166791263';
const MLM_CONTACT_US_LEVARTI_FORM = 'https://form.jotform.com/250755932698270';

interface IProps {
  isRsiClub?: boolean;
}

export function ContactUsForm(props: IProps) {
  const { isRsiClub } = props;

  const menuStore: IMenuState = useSelector((state: FunctionalRootState) => state.navigationMenuStore);
  const { account }: ILoginState = useSelector((state: FunctionalRootState) => state.loginStore);

  if (isRsiClub) {
    return null;
  }

  const isVacationInspiration = menuStore?.items?.organizationId && account?.vacationInspirationsOrgIds?.includes(menuStore?.items?.organizationId);
  const isVPT = menuStore?.items?.organizationId && account?.vptOrgIds?.includes(menuStore?.items?.organizationId);

  const fomrId = isVacationInspiration ? 
                    '250065136933252' : 
                    isVPT ? 
                          '250134098212246' :
                          '220953995609167';

  if (menuStore?.loading || !menuStore?.items) {
    return (
      <div className="contact-us-form loading-form">
        <Loading />
      </div>);
  }

  const isLevarti = account?.levartiOrgIds?.includes(menuStore?.items?.organizationId as number);
  const mlmURL = isLevarti ? MLM_CONTACT_US_LEVARTI_FORM : MLM_CONTACT_US_FORM;

  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="currentColor" class="bi bi-plus" viewBox="0 0 13 13"><path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/></svg>`;
  const phoneNumbersContainer = `<label>If you are located outside of the United States, you may use one of our international numbers:</label><br><div style="grid-template-columns: 1fr 1fr 1fr; display: grid; margin-top: 15px;">${menuStore?.items?.internationalNumbers?.map((number) => `<label style="font-size: 13.33px; margin-bottom: 10px;">${number.country}<br>${svg}${number.phone.replace('+', '')}</label>`).join('')}</div><br>`;
  
  return (
    <div className="contact-us-form">
      {!menuStore?.items?.isMLM ? (
        <JotformEmbed {...{ src: `https://form.jotform.com/${fomrId}?Look=${menuStore?.items?.rsiId}&fullName[first]=${menuStore?.items?.firstName}&fullName[last]=${menuStore?.items?.lastName}&email=${menuStore?.items?.email}&phoneNumbers=${phoneNumbersContainer}`, frameBorder: '0' }} />) : (
        <JotformEmbed {...{ src: `${mlmURL}?Look=${menuStore?.items?.rsiId}&fullName[first]=${menuStore?.items?.firstName}&fullName[last]=${menuStore?.items?.lastName}&email=${menuStore?.items?.email}`, frameBorder: '0' }} />
      )}
    </div>
  );
}
